import AccountService from "./AccountService"
import Anchor from "../models/Anchor"

class AnchorService
{
    async getAnchors(options: any): Promise<Anchor[]> {
        let data = await AccountService.sendRequest('GET_ANCHORS', { options: options });
        return data.map((item: any)=>{return new Anchor(item)});
    }

    async updateAnchors(anchors: any): Promise<string> {
        return await AccountService.sendRequest('UPDATE_ANCHORS', { anchors: anchors })
    }
}

const g_anchorService = new AnchorService();
export default g_anchorService;
